import { parseQuotationDTO, QuotationDTO } from 'components/ordering/quotation/api/dtos/quotation-dto.js'
import { NotFoundError } from 'components/ordering/quotation/api/dtos/error.js'
import { QuotationRequest } from 'components/ordering/quotation/api/quotation-request.js'

export class GetOpenQuotation extends QuotationRequest<QuotationDTO | null, NotFoundError> {
  path = 'quotation/open/'
  override expectedErrors = [404] as const

  override parseResponse = parseQuotationDTO
}
